import React from 'react'
import { observer } from 'mobx-react'
import c from 'classnames'
import Input from '../Input'
import Tooltip from '../../../../csr/components/Tooltip/Tooltip'

const spanBaseClasses = ['text-sm', 'font-bold', 'mb-1']

const spanDefaultClasses = ['text-gray-400']

const spanInvertedClasses = ['text-white']

const InputWrapper = ({
  as: Component = Input,
  label,
  onChange,
  value,
  inputStore = null,
  inputRef = null,
  inverted = false,
  error = '',
  tooltipText = '',
  ...props
}:any) => {
  const spanStyleClasses = !inverted ? spanDefaultClasses : spanInvertedClasses
  const spanClasses = [...spanBaseClasses, ...spanStyleClasses, props.spanClass]

  let val = value
  let errorMsg = error

  if (inputStore) {
    val = inputStore.value
    errorMsg = inputStore.errorMessage
  }

  return (
    <label className="flex flex-col items-start flex-grow">
        <span className={c(spanClasses)}>{label}
          {tooltipText &&
            <>
              <img data-tooltip-id={`tooltip-${label}`} data-tooltip-content={tooltipText} src="/icons/tooltip.svg" alt="tooltip" className="inline-block ml-2 mb-1 opacity-40" />
              <Tooltip className="rounded-md font-normal bg-gray-800 max-w-sm text-center" id={`tooltip-${label}`}/>
            </>
          }
        </span>
      <Component
        error={errorMsg !== ''}
        inputRef={inputRef}
        inverted={inverted}
        onChange={onChange}
        label={label}
        value={val}
        {...props}
      />
      {errorMsg !== '' && <div className="text-red-400 text-xs pt-1">{errorMsg}</div>}
    </label>
  )
}

export default observer(InputWrapper)
